export default {
	"1abdc219e7ce42941821c7bcc84f6d23": "您登陆的账号未分段购买或订阅过该商品，无法转年",
	"d71485dcb16d0de54249d0606d0a5ed0": "请选择可用代金券",
	"82147f222955596655160ee6ef03d574": "分段解锁转年",
	"7018ac152f55fc2bc0687d4faccc575c": "已付金额",
	"abc4d5c7f1c76f5d838c83d938aa73b2": "代金券",
	"3ea640feb27ff2c83e8b2eb9e94da9a4": "转年成功后，您可在原订单中查看您的转年信息；若您购买的为自动续费类商品，转年后自动续费将会被系统自动取消，不会再重复扣费；转年成功后，不支持退款。",
	"d868329abbb1b37dd54042e75df8cf6a": "转年优惠抵扣:"
}
